import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Fade from "react-reveal/Fade"

import { theme } from "Theme"

import { ActionButton } from "Components"

const Wrapper = styled.section`
  background: ${({ dark }) => (dark ? theme.colors.white.light : theme.colors.white.base)};
  border-bottom: ${({ dark }) =>
    dark ? `1px solid ${theme.colors.white.light}` : `1px solid ${theme.colors.white.grey}`};
  color: ${theme.colors.black.base};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    margin: 0 auto;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    margin: 0 auto;
  }
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

const Content = styled.div`
  color: inherit;
  max-width: ${theme.layout.base};
  width: 100%;
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  justify-content: space-between;
  margin: 0 auto;
  align-items: flex-start;
  font-size: ${theme.fontSize.large};
`

const SectionSponsorsGrid = ({
  dark,

  image,
  title,

  cta_action,
  cta_action_text,
  cta_url,
  cta_text,
  cta_url_1,
  cta_text_1,
  children,
}) => (
  <Wrapper dark={dark ? 1 : undefined}>
    {image && (
      <GatsbyImage
        alt={""}
        title={title}
        objectFit="contain"
        objectPosition="50% 50%"
        image={image.childImageSharp.gatsbyImageData}
      />
    )}
    <Content>
      <Fade>
        <>
          <div>
            {cta_text && cta_url && (
              <ActionButton href={cta_url} title={cta_text}>
                {cta_text}
              </ActionButton>
            )}
            {cta_text_1 && cta_url_1 && (
              <ActionButton href={cta_url_1} title={cta_text_1}>
                {cta_text_1}
              </ActionButton>
            )}
            {cta_action && cta_action_text && (
              <ActionButton onClick={cta_action} title={cta_action_text}>
                {cta_action_text}
              </ActionButton>
            )}
          </div>
          {children && children}
        </>
      </Fade>
    </Content>
  </Wrapper>
)

export default SectionSponsorsGrid
